import {
  TrophyIcon,
  GlobeIcon,
  PenToolIcon,
  UsersIcon,
  TrendingUpIcon,
  ActivityIcon,
  MegaphoneIcon,
  PresentationIcon,
  TargetIcon,
  RocketIcon,
  UserPlusIcon,
  Settings2Icon,
  CodeIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type HubSpoke = {
  label: string
  icon: LucideIcon
}

export const hubSpokes: HubSpoke[] = [
  { label: 'Buying signals', icon: ActivityIcon },
  { label: 'Leaderboards', icon: TrophyIcon },
  { label: 'Websites', icon: GlobeIcon },
  { label: 'Content creation', icon: PenToolIcon },
  { label: 'Lead management', icon: UsersIcon },
  { label: 'Marketing', icon: TrendingUpIcon },
  { label: 'MCP & APIs', icon: CodeIcon },
]

export const hiddenHubSpokes: HubSpoke[] = [
  { label: 'Listing marketing', icon: MegaphoneIcon },
  { label: 'Listing presentations', icon: PresentationIcon },
  { label: 'Coaching', icon: TargetIcon },
  { label: 'Onboarding', icon: RocketIcon },
  { label: 'Recruiting', icon: UserPlusIcon },
  { label: 'Team operations', icon: Settings2Icon },
  // Integrations stay visible in both views
  { label: 'MCP & APIs', icon: CodeIcon },
]
